// Mobile offline cache (upstream CRM.tsx MobileAdmin): react-query is persisted to localStorage for 24 h,
// so it holds lead data. Logout removes it (batch 7 final review M11; PIA §6).

/** localStorage key of the persisted react-query cache (the persister's default, set explicitly). */
export const PERSISTED_QUERY_CACHE_KEY = "REACT_QUERY_OFFLINE_CACHE";

/** Removes the persisted cache. Never throws: logout must go on even when storage is unavailable. */
export function clearPersistedQueryCache(
  storage: Pick<Storage, "removeItem"> = localStorage,
): void {
  try {
    storage.removeItem(PERSISTED_QUERY_CACHE_KEY);
  } catch {
    // Private mode or blocked storage: nothing was persisted there either.
  }
}
